<div class="content-tab-wrapper">
    <ul>
        <li><a [routerLink]="'/activation-message/category'" routerLinkActive="active">Category</a></li>
        <li><a [routerLink]="'/activation-message/messages'" routerLinkActive="active">Messages</a></li>
        <li><a [routerLink]="'/activation-message/tactics'" routerLinkActive="active">Tactics</a></li>
        <li><a [routerLink]="'/activation-message/current-test'" routerLinkActive="active">Current Tests</a></li>
    </ul>
</div>